import { getApiClient } from '@aslanpay/portal-common-lib';

import { getFilename } from 'app/services/reconciliationsApiHandler';

import { ListPage } from 'app/types/reconciliations';
import {
  FetchSalaryReconciliationsRequest,
  QueueSalaryReconciliationRequest,
  ResolveSalaryDiscrepancyRequest,
  SalaryReconciliationCompaniesRequest,
  SalaryReconciliationCompany,
  SalaryReconciliationDiscrepanciesRequest,
  SalaryReconciliationDiscrepancy,
  SalaryReconciliationIndividualsRequest,
  SalaryReconciliationReport,
  SalaryReconciliationReportRequest,
  SalaryReconciliationRun,
  SalaryReconciliationUncheckedIndividual,
} from 'app/types/salaryReconciliations';

export const SALARY_RECONCILIATIONS_PATH = '/wallet-manager/salary/reconciliations';

const SalaryReconciliationsApiHandler = {
  listReconciliations: async ({
    companyId,
    status,
    page,
    size,
  }: FetchSalaryReconciliationsRequest) => {
    const { data } = await getApiClient().get<ListPage<SalaryReconciliationRun>>(
      SALARY_RECONCILIATIONS_PATH,
      { params: { companyId, status, page, size }, paramsSerializer: { indexes: null } }
    );
    return data;
  },

  getReconciliation: async (id: string) => {
    const { data } = await getApiClient().get<SalaryReconciliationRun>(
      `${SALARY_RECONCILIATIONS_PATH}/${id}`
    );
    return data;
  },

  queueReconciliation: async (body: QueueSalaryReconciliationRequest) => {
    const { data } = await getApiClient().post<SalaryReconciliationRun>(
      SALARY_RECONCILIATIONS_PATH,
      body
    );
    return data;
  },

  getReconciliationReport: async ({ id, companyId }: SalaryReconciliationReportRequest) => {
    const { data } = await getApiClient().get<SalaryReconciliationReport>(
      `${SALARY_RECONCILIATIONS_PATH}/${id}/report`,
      { params: { companyId } }
    );
    return data;
  },

  listReconciliationCompanies: async ({
    id,
    companyId,
    status,
    page,
    size,
  }: SalaryReconciliationCompaniesRequest) => {
    const { data } = await getApiClient().get<ListPage<SalaryReconciliationCompany>>(
      `${SALARY_RECONCILIATIONS_PATH}/${id}/companies`,
      { params: { companyId, status, page, size } }
    );
    return data;
  },

  listUncheckedIndividuals: async ({
    id,
    companyId,
    page,
    size,
  }: SalaryReconciliationIndividualsRequest) => {
    const { data } = await getApiClient().get<ListPage<SalaryReconciliationUncheckedIndividual>>(
      `${SALARY_RECONCILIATIONS_PATH}/${id}/individuals`,
      { params: { companyId, page, size } }
    );
    return data;
  },

  listDiscrepancies: async ({
    id,
    view,
    companyId,
    page,
    size,
  }: SalaryReconciliationDiscrepanciesRequest) => {
    const { data } = await getApiClient().get<ListPage<SalaryReconciliationDiscrepancy>>(
      `${SALARY_RECONCILIATIONS_PATH}/${id}/discrepancies`,
      { params: { view, companyId, page, size } }
    );
    return data;
  },

  resolveDiscrepancy: async ({ id, note }: ResolveSalaryDiscrepancyRequest) => {
    const { data } = await getApiClient().post<SalaryReconciliationDiscrepancy>(
      `${SALARY_RECONCILIATIONS_PATH}/discrepancies/${id}/resolve`,
      { note }
    );
    return data;
  },

  downloadReconciliationReport: async ({ id, companyId }: SalaryReconciliationReportRequest) => {
    const { data, headers } = await getApiClient().get<Blob>(
      `${SALARY_RECONCILIATIONS_PATH}/${id}/report/download`,
      { params: { companyId }, responseType: 'blob' }
    );

    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = getFilename(headers['content-disposition'] as string | undefined);
    link.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
  },
};

export default SalaryReconciliationsApiHandler;
